export default __webpack_public_path__ + "static/media/CNo.83-4.9841cdb2.jpg";